import { createResource, useResource } from '@/lib/i18n'
import dynamic from 'next/dynamic'
import React from 'react'
import styled from 'styled-components'

const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))

const resource = createResource({
  id: { title: 'Sampai jumpa di acara kami berikutnya. Nantikan segera!' },
  en: { title: 'See you at our next event. Stay tuned!' },
})
const EVENT = () => {
  const { t } = useResource(resource)

  return (
    <Wrapper>
      <KPHead metaTitle="event" />
      <TopNavigation />
      <section className="tip">
        <div className="message">
          <h2>{t('title')}</h2>
        </div>
      </section>
      <Footer />
    </Wrapper>
  )
}
const Wrapper = styled.div`
  background: white;
  .tip {
    padding-top: 152px;
    text-align: center;
    color: #1cc812;
  }
`
export default EVENT
